import { Component, OnInit, ViewChild, forwardRef } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  ToastController,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NoticiaDetalhesPage } from "../../components/noticia-detalhes/noticia-detalhes.page";
import { NoticiaProvider } from "src/app/services/noticia/noticia";
import { UserProvider } from "src/app/services/user/user";
import { Router } from "@angular/router";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ListImagePeqComponent } from "src/app/components/list-image-peq/list-image-peq.component";
import { ListImagemComponent } from "src/app/components/list-imagem/list-imagem.component";
import { ListImagemResumoComponent } from "src/app/components/list-imagem-resumo/list-imagem-resumo.component";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ListTituloResumoComponent } from "src/app/components/list-titulo-resumo/list-titulo-resumo.component";
import { format, subDays } from "date-fns";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ListImageAccordionComponent } from "src/app/components/list-image-accordion/list-image-accordion.component";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";

declare var instituicaoConstants: { IS_PWA: any };
@Component({
  selector: "app-noticia",
  templateUrl: "./noticia.page.html",
  styleUrls: ["./noticia.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ListImagePeqComponent,
    ListImagemComponent,
    ListImagemResumoComponent,
    LoadingSpinnerComponent,
    ListTituloResumoComponent,
    SemRegistroComponent,
    ListImageAccordionComponent,
    NomenclaturaPipe
  ],
})
export class NoticiaPage implements OnInit {
  noticias: any[] = [];
  categorias: any[] = [];
  categoria: any = {};
  categoriaSelecionada: any = {};
  filtroCategorias: any[] = [];
  titulo: any = "noticias";
  isPWA: boolean = instituicaoConstants.IS_PWA;
  @ViewChild("divNoticias") divNoticias!: { nativeElement: HTMLElement };
  currentUrl: boolean;
  loaded = false;
  noticiasAno = [];
  target: string;
  texto: string;
  filtro: Record<string, string> = {
    dataInicio: format(subDays(new Date(), 180), "yyyy-MM-dd"),
  };
  dateFilter = format(subDays(new Date(), 180), "yyyy-MM-dd");
  pesquisa: any;
  debounceTimer: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public noticiaProvider: NoticiaProvider,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public userProvider: UserProvider,
    public router: Router,
    private location: Location,
    public alertCtrl: AlertController
  ) {
    this.filtroCategorias = this.navParams.get("categorias");
    this.titulo = this.navParams.get("titulo") || this.titulo;
    this.target = this.navParams.get("target");
    this.texto = this.navParams.get("texto");
    this.target === "noticia_mes" ? this.loadListNoticia(this.filtro) : this.loadCategoriaList();
    this.currentUrl = this.location.path() === "/tabs/NoticiaPage";
  }

  ngOnInit(): void {}

  selecionarCategoria(categoria: any) {
    this.pesquisa = "";
    if (categoria.detail.value.id === this.categoria.id) {
      return;
    }

    this.noticiaProvider.getNoticias(categoria.detail.value.id, null).subscribe((data) => {
      this.categoria = categoria.detail.value;
      this.noticias = data;
    });
  }

  public loadListNoticia(filtro: any) {
    this.noticiaProvider.postNoticiaListAno(filtro, this.filtroCategorias).subscribe((noticias) => {
      this.noticiasAno = noticias;

      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  buscarNoticias(categoria: any, pesquisa: any) {
    this.noticiaProvider.getNoticias(categoria, pesquisa).subscribe((data) => {
      this.noticias = data;
    });
  }

  public loadCategoriaList() {
    this.noticiaProvider.getInicioNoticias().subscribe();
    this.noticiaProvider.getCategorias(this.filtroCategorias).subscribe((data) => {
      this.categorias = data;

      if (this.categorias.length > 0) {
        this.categoria = this.categorias[0];
        this.categoriaSelecionada = this.categorias[0];
        this.buscarNoticias(this.categoria.id, null);
      }

      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  async abrirDetalhes(noticia: { id: string }) {
    const modalPage = await this.modalCtrl.create({
      component: NoticiaDetalhesPage,
      componentProps: { id: noticia.id },
    });
    modalPage.present();
  }

  onDateSelected(date: string) {
    this.loaded = false;
    this.filtro["dataInicio"] = date;
    this.dateFilter = date;
    this.loadListNoticia(this.filtro);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onInput() {
    clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      if (this.categoria?.id) {
        this.buscarNoticias(this.categoria.id, this.pesquisa);
      }
    }, 500);
  }
}
